const { Tracker } = require('@reverbdotcom/discovery-ui');

const CLICK = 'click';

function trackClick(e) {
  const clickTarget = $(e.currentTarget);
  const moduleWithLinks = clickTarget.closest('[data-track-clicks]');
  const data = Object.assign({}, moduleWithLinks.data(), clickTarget.data());
  const componentName = data.trackClicks;

  // only fire tracking if there is a name given
  if (!componentName || !componentName.length) { return; }

  Tracker.trackInteraction({
    url: e.currentTarget.href,
    name: componentName,
    clientSide: data.trackInstant !== undefined,
    interaction: data.trackInteraction || CLICK,
    position: Number(data.trackPosition || 0),
    id: data.trackEntityId,
    type: data.trackEntityType,
    context: data.trackContext,
  });
}

// Separate function so we can test a given dom
function bindTracking(dom) {
  // a tags and buttons track themselves
  $(dom).on('click.metrics', 'a[data-track-clicks]', trackClick);
  $(dom).on('click.metrics', 'button[data-track-clicks]', trackClick);
  $(dom).on('click.metrics', 'input[data-track-clicks]', trackClick);

  // divs and other tags track links inside
  $(dom).on('click.metrics', '[data-track-clicks] a', trackClick);
}

function trackComponentView(el) {
  const data = el.data();
  const componentName = data.trackView;

  if (!componentName || !componentName.length) { return; }

  const ids = el.find('[data-track-entity-id]').map(function () {
    return $(this).data().trackEntityId;
  }).get();

  Tracker.view({
    name: componentName,
    ids,
    type: data.trackEntityType,
    context: data.trackContext,
  });
}

function trackViews(dom) {
  $(dom).find('[data-track-view]').each(function () {
    trackComponentView($(this));
  });
}

function init() {
  bindTracking(document);
  trackViews(document);
}

module.exports = {
  init,
  bindTracking,
  trackViews,
};



// WEBPACK FOOTER //
// ./javascripts/components/shared/track_interaction.js